import ActionMenu from "../../../../components/actionMenu/ActionMenu";
import { TableItemId } from "../../../../components/tables/TableWidget";
import { TableItemType } from "../../../../components/tables/tableContext/TableContext";
import { BorderouHistoryListInterface } from "../../../../redux/interfaces/expedition.interface";

import { useAppDispatch } from "../../../../redux/hooks";
import { getDownloadBorderou } from "../../../../redux/api/expedition.api";

function BorderouHistoryTableActionsButtons({
  crudData,
}: {
  itemId: TableItemId;
  tableItemData: TableItemType[];
  crudData?: BorderouHistoryListInterface;
  tableContext?: any;
}) {
  const dispatch = useAppDispatch();

  const handleClickDownloadButton = () => {
    if (!crudData?.nod) {
      return "";
    }

    dispatch(
      getDownloadBorderou({
        idBorderou: crudData.idBorderou,
        nod: crudData?.nod,
      }),
    );

    return;
  };

  return (
    <ActionMenu
      minItemsForMenu={2}
      title={crudData?.nod}
      ariaLabel={`Actiuni pentru borderoul ${crudData?.idBorderou ?? ""}`}
      items={[
        {
          id: "download-borderou",
          label: "Descarca borderou",
          icon: "DOWNLOAD",
          kind: "download",
          tooltip: !crudData?.nod
            ? "Borderoul nu are un nod asociat pentru descarcarea documentelor."
            : "Descarca arhiva cu documentele borderoului.",
          disabled: !crudData?.nod,
          onClick: handleClickDownloadButton,
        },
      ]}
    />
  );
}

export default BorderouHistoryTableActionsButtons;
